require('../../modules/es6.symbol');
module.exports = require('../../modules/_core').Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/library/fn/object/get-own-property-symbols.js
// module id = ../node_modules/core-js/library/fn/object/get-own-property-symbols.js
// module chunks = 0